export default "<gt-header-image [slides]=\"slides\"></gt-header-image>";